exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-xl[data-v-34f866fa]{font-size:20px;font-weight:700}.text-md[data-v-34f866fa]{font-size:15px;font-weight:700}.text-log[data-v-34f866fa]{font-size:15px;font-style:italic}.notif-panel[data-v-34f866fa]{height:100%;background-color:#d9dfe9;padding-bottom:10px;margin:10px;border-radius:10px}.notif-title[data-v-34f866fa]{min-height:10%;background-color:#367fa9}.notif-content[data-v-34f866fa]{height:90%;margin-top:10px}.notif-entry[data-v-34f866fa]{min-height:30px;background-color:#fff;border-radius:10px;padding:10px;margin:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/views/users/UsersAdminActions.vue?vue&type=style&index=0&id=34f866fa&prod&scoped=true&lang=css&
// module id = 1444
// module chunks = 0